import { render, staticRenderFns } from "./workList.vue?vue&type=template&id=530339a2&scoped=true"
import script from "./workList.vue?vue&type=script&lang=js"
export * from "./workList.vue?vue&type=script&lang=js"
import style0 from "./workList.vue?vue&type=style&index=0&id=530339a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530339a2",
  null
  
)

export default component.exports